import { Link } from 'react-router-dom'

// styles
import './Components.css'

export default function Avatar({pic, user}) {
  var f = ''
  var l = ''
  if (user && user.first_name) {
    f = user.first_name[0]
  }
  if (user && user.last_name) {
    l = user.last_name[0]
  }
  
  return pic ? (
    <div className='avatar'>
      <Link to='/account-settings'>
        <img src={pic} alt='user avatar'/>
      </Link>
    </div>
  ) : 
  (
    <Link to='/account-settings'>
      <div className='avatar'>
          <h2>{`${f}${l}`}</h2>
      </div>
    </Link>
  )
}

